export function isLedgerSyncTruncated(data) {
  return data?.sync?.vouchers?.truncated === true;
}
